import {
  Component,
  Input,
  Output,
  OnInit,
  OnDestroy,
  EventEmitter,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BehaviorSubject, Subject } from 'rxjs';
import { IVoice } from 'src/app/talent-litmus-core/game-core/level1-core/voice-core';
import { VoiceService } from '../voice.service';
import {
  ToasterPosition,
  ToasterService,
} from 'src/app/shared/services/toaster/toaster.service';
import { takeUntil } from 'rxjs/operators';
import { ApiService } from 'src/app/shared/services/api/api/api.service';

@Component({
  selector: 'app-voice-form',
  templateUrl: './voice-form.component.html',
})
export class VoiceFormComponent implements OnInit, OnDestroy {
  private _unsubscribe$ = new Subject<void>();
  voiceFormGroup: FormGroup;
  previewURL = '';

  uploading$ = new BehaviorSubject<boolean>(false);

  @Input() action: 'edit' | 'clone';

  @Output()
  formValidityChangeEvent = new EventEmitter<boolean>();

  @Output()
  isUploadChangeEvent = new EventEmitter<boolean>();

  @Input()
  public set voice(voice: IVoice) {
    this._initForm(voice);
  }

  private _initForm(voice: IVoice): void {
    this.voiceFormGroup = this._fb.group({
      _id: voice._id,
      name: [voice.name, [Validators.required]],
      url: [voice.url, [Validators.required]],
    });
    this.previewURL = voice.url;
  }

  constructor(
    private _api: ApiService,
    private _fb: FormBuilder,
    public voiceService: VoiceService,
    private _toast: ToasterService,
  ) {}

  ngOnInit(): void {
    this.voiceFormGroup.valueChanges
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe(() => {
        this.formValidityChangeEvent.emit(this.voiceFormGroup.invalid);
      });
  }

  onSubmit(): IVoice {
    return this.voiceFormGroup.getRawValue();
  }

  upload(dataInput): void {
    this.uploading$.next(true);
    if (this.action !== 'clone') {
      this.deleteVoiceFile();
    }
    const formData = new FormData();
    formData.append('file', dataInput.data);
    this._api
      .uploadVoices(formData)
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe(
        (data: string) => {
          this.uploading$.next(false);
          this._toast.showSuccess(
            'Music uploaded successfully',
            ToasterPosition.topRightSticky,
          );
          this.isUploadChangeEvent.emit(true);
          this.voiceFormGroup.controls.url.setValue(data);
          this.previewURL = data;
        },
        (err) => {
          this.uploading$.next(false);
          console.log(err);
          this._toast.showError(
            err?.error?.message,
            ToasterPosition.topRightSticky,
          );
        },
      );
  }

  deleteVoiceFile(url?: string): void {
    const pUrl = url || this.previewURL;

    if (pUrl) {
      const formInput = { url: pUrl };

      this._api
        .deleteVoicefile(formInput)
        .pipe(takeUntil(this._unsubscribe$))
        .subscribe(
          (): void => {
            this._toast.showSuccess(
              'Previous music file removed successfully',
              ToasterPosition.topRightSticky,
            );
          },
          (err) => {
            this._toast.showError(
              err?.error?.message,
              ToasterPosition.topRightSticky,
            );
          },
        );
    }
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }
}
